import { useEffect } from "react";
import { useAuth } from "../auth";

// "Recently viewed" — the last detail pages this user opened, kept per user in localStorage for ⌘K.
const MAX = 8;
const key = (uid) => `traide-recent-${uid || "anon"}`;

export function readRecent(uid) {
  try { return JSON.parse(localStorage.getItem(key(uid)) || "[]"); } catch { return []; }
}

export function clearRecent(uid) { localStorage.removeItem(key(uid)); }

export function recordRecent(uid, item) {
  if (!item?.id || !item?.link) return;
  const rest = readRecent(uid).filter((r) => !(r.type === item.type && r.id === item.id));
  localStorage.setItem(key(uid), JSON.stringify([{ ...item, at: Date.now() }, ...rest].slice(0, MAX)));
}

// Call from a detail page once its data is loaded: useRecordRecent(data && { type: "job", id, title, sub, link }).
export function useRecordRecent(item) {
  const { user } = useAuth();
  const uid = user?.id;
  useEffect(() => { if (item && uid) recordRecent(uid, item); }, [uid, item?.type, item?.id, item?.title, item?.sub]); // eslint-disable-line react-hooks/exhaustive-deps
}
